// TODO: check how to sort by adder.name ==> adder_id ==> how to get id on sorting? 

export default {
  id: "id",
  content: "content",
  scheduledTo: "scheduled_to",
  adderName: "admins.name", // FIXME:
};
